// Utils
import isDigitalAsset from './isDigitalAsset';

const isProductOutOfStock = (product) => {
  if (isDigitalAsset(product)) {
    return false;
  }
  return product?.product_available_qty <= 0 && !product?.offer_inactive;
};

export default isProductOutOfStock;
